import { render, staticRenderFns } from "./dealerIndex.vue?vue&type=template&id=8aff4da8&"
import script from "./dealerIndex.vue?vue&type=script&lang=js&"
export * from "./dealerIndex.vue?vue&type=script&lang=js&"
import style0 from "./dealerIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports